{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "(зекономте {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} днів безкоштовно",
    "{amount} off": "Знижка {amount}",
    "{amount} off for first {number} months.": "Знижка {amount} для перших {number} місяців.",
    "{amount} off for first {period}.": "Знижка {amount} для першого {period}.",
    "{amount} off forever.": "Знижка {amount} назавжди.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_many": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "Знижка {discount}%",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} більше не отримуватиме розсилку {newsletterName}.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} більше не отримуватиме електронні листи, коли хтось відповідає на ваші коментарі.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} більше не отримуватиме цю розсилку.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "Безплатно {trialDays} дні(-в)",
    "{years} years": "",
    "+1 (123) 456-7890": "+1 (123) 456-7890",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Oбліковий запис",
    "Account details updated successfully": "Дані облікового запису успішно оновлено",
    "Account settings": "Налаштування облікового запису",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Після закінчення безплатного періоду, з тебе буде стягнена вартість за обраний тариф. Ти завжди можеш скасувати послугу до цього часу.",
    "Already a member?": "Вже є учасником?",
    "An error occurred": "Сталася помилка",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Сталася неочікувана помилка. Спробуйте ще раз або <a>зв’яжіться зі службою підтримки</a>, якщо помилка не зникне.",
    "Back": "Назад",
    "Back to Log in": "Повернутись до входу",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Чорна п`ятниця",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Скасуй будь-коли.",
    "Cancel subscription": "Скасуй підписку",
    "Canceled": "",
    "Cancellation reason": "Причина скасування",
    "Change": "Змінити",
    "Change plan": "Змінити план",
    "Check spam & promotions folders": "Перевірте папки зі спамом і рекламними акціями",
    "Check with your mail provider": "Зверніться до свого постачальника послуг електронної пошти",
    "Check your inbox to verify email update": "Перевірте свою поштову скриньку, щоб підтвердити оновлення електронної пошти",
    "Choose": "Оберіть",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Оберіть інший план",
    "Choose a plan": "Оберіть план",
    "Choose a tier": "",
    "Choose an option": "",
    "Choose your newsletters": "Оберіть свої підписки",
    "City": "",
    "Click here to retry": "Натисніть тут, щоб повторити спробу",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Закрити",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Коментарі",
    "Complimentary": "Безкоштовно",
    "Confirm": "Підтвердь",
    "Confirm cancellation": "Підтвердити скасусання",
    "Confirm subscription": "Підтвердити підписку",
    "Contact support": "Звернутись до служби підтримки",
    "Continue": "Продовжити",
    "Continue subscription": "Продовжити підписку",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Не вдалося створити сеанс оформлення замовлення Stripe",
    "Could not sign in. Login link expired.": "Неможливо увійти. Термін дії посилання для входу закінчився.",
    "Could not update email! Invalid link.": "Неможливо оновити електронну адресу! Недійсне посилання.",
    "Country": "",
    "Create a new contact": "Створити новий контакт",
    "Current plan": "Поточний план",
    "Delete account": "Видалити обліковий запис",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Ви не хотіли цього робити? Керуйте своїми параметрами <button>тут</button>.",
    "Don't have an account?": "Не маєш облікового запису?",
    "Edit": "Редагувати",
    "Email": "Електронна пошта",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Електронна розсилка",
    "Email newsletter settings updated": "Оновлено параметри електронної розсилки",
    "Email preferences": "Налаштування електронної пошти",
    "Email preferences updated.": "",
    "Emails": "Електронні листи",
    "Emails disabled": "Електронна пошта вимкнена",
    "Ends {offerEndDate}": "Закунчується {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Введіть свій імейл",
    "Enter your name": "Введіть імʼя",
    "Error": "Помилка",
    "Expires {expiryDate}": "Термін дії закінчується {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Не вдалося скасувати підписку, повторіть спробу",
    "Failed to log in, please try again": "Не вдалося ввійти, спробуйте ще раз",
    "Failed to log out, please try again": "Не вдалося вийти, спробуйте ще раз",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Не вдалося обробити замовлення, спробуйте ще раз",
    "Failed to send magic link email": "Не вдалося надіслати електронний лист із одноразовим посиланням",
    "Failed to send verification email": "Не вдалося надіслати електронний лист для підтвердження",
    "Failed to sign up, please try again": "Не вдалося зареєструватися, повторіть спробу",
    "Failed to update account data": "Не вдалося оновити дані облікового запису",
    "Failed to update account details": "Не вдалося оновити дані облікового запису",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Не вдалося оновити налаштування розсилки",
    "Failed to update subscription, please try again": "Не вдалося оновити підписку, повторіть спробу",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Назавжди",
    "Free Trial – Ends {trialEnd}": "Безкоштовна пробна версія – закінчується {trialEnd}",
    "From": "",
    "Get help": "Отримати допомогу",
    "Get in touch for help": "Звертайтесь по допомогу",
    "Get notified when someone replies to your comment": "Отримувати повідомлення коли хтось відповість на твій коментар",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Дати відгук на цю публікацію",
    "Help! I'm not receiving emails": "Допоможіть! Я не отримую електронні листи",
    "Here are a few other sites you may enjoy.": "Ось кілька інших сайтів, які можуть вам сподобатися.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Якщо розсилку позначено як спам, електронні листи для цієї адреси автоматично вимикаються, щоб ви більше не отримували небажаних повідомлень.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Якщо скарга на спам була випадковою або ви хочете знову отримувати електронні листи, ви можете знову підписатися на електронні листи, натиснувши кнопку на попередньому екрані.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Якщо ви скасуєте свою підписку зараз, ви матимете доступ до {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Якщо у вас є корпоративний або державний обліковий запис електронної пошти, зверніться до свого ІТ-відділу та попросіть їх дозволити отримувати електронні листи від {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Посилання для входу було надіслано на твою пошту. Якщо воно не прийде протягом 3 хвилин, перевірь папку зі спамом.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Якщо ви хочете знову почати отримувати електронні листи, найкращим наступним кроком буде перевірити свою адресу електронної пошти на наявність проблем, а потім на попередньому екрані натиснути Підписатися знову.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Якщо ви не отримуєте розсилку електронною поштою, на яку підписалися, то ось декілька речей щоб перевірити.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Якщо ви виконали всі ці перевірки, але досі не отримуєте електронних листів, ви можете звернутись до нас по допомогу, зв’язавшись з {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Якщо під час спроби надсилання розсилки виникає постійна помилка, електронні листи в обліковому записі буде вимкнено.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "У своєму поштовому клієнті додайте {senderEmail} до списку контактів. Це сигналізує вашому постачальнику послуг електронної пошти, що листам, надісланим із цієї адреси, слід довіряти.",
    "Invalid email address": "Недійсна адреса електронної пошти",
    "Invalid verification code": "",
    "Jamie Larson": "Джеймі Ларсон",
    "jamie@example.com": "jamie@example.com",
    "Less like this": "Менше подібних",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Переконайтеся, що електронні листи випадково не потрапляють у папку \"Спам\" або \"Реклама\" вашої папки \"Вхідні\". Якщо вони так і є, натисніть \"Позначити як не спам\" і/або \"Перемістити до вхідних\".",
    "Manage": "Керувати",
    "Maybe later": "Можливо пізніше",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Членство недоступне, зв’яжіться з власником, щоб отримати доступ.",
    "month": "Місяць",
    "Monthly": "Щомісяця",
    "More like this": "Більше подібних",
    "More options": "",
    "Name": "Ім'я",
    "Need more help? Contact support": "Потрібна допомога? Зверніться до служби підтримки",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Розсилки можуть бути вимкнені у вашому обліковому записі з двох причин: попередній електронний лист було позначено як спам або спроба надіслати електронний лист призвела до збою (чи відмови).",
    "No member exists with this e-mail address.": "Не існує жодного учасника з цією адресою електронної пошти.",
    "No options found": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Не приходять листи?",
    "Now": "",
    "Now check your email!": "А тепер перевір свою пошту!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Якщо після повторної підписки ви все ще не бачите електронних листів у папці \"Вхідні\", перевірте папку зі спамом. Деякі постачальники вхідних повідомлень реєструють попередні скарги на спам і продовжуватимуть позначати електронні листи. Якщо це станеться, позначте устанню розсилку як \"Не спам\", щоб повернути його до основної папки \"Вхідні\".",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Постійний збій (відмова)",
    "Phone number": "Номер телефона",
    "Plan": "План",
    "Plan checkout was cancelled.": "Оформлення плану скасовано.",
    "Plan upgrade was cancelled.": "Оновлення плану скасовано.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Будь ласка, зв’яжіться з {supportAddress}, щоб налаштувати безкоштовну підписку.",
    "Please enter {fieldName}": "Будь ласка, введіть {fieldName}",
    "Please fill in required fields": "Будь ласка, заповніть обов'язкові поля",
    "Podcasts": "",
    "Postal code": "",
    "Re-enable emails": "Знову включити пошту",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Рекомендації",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Remove {option}": "",
    "Renews at {price}.": "Поновлення за {price}.",
    "Resume subscription": "",
    "Retry": "Повтори спробу",
    "Save": "Зберегти",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Security verification": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Відправляється посилання для входу...",
    "Sending...": "Відправляється...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Показати все",
    "Sign in": "Вхід",
    "Sign out": "Вихід",
    "Sign up": "Реєстрація",
    "Signup error: Invalid link": "Помилка реєстрації: недійсне посилання",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "Щось пішло не так, спробуйте пізніше.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Вибачте, це не спрацювало.",
    "Spam complaints": "Скарги на спам",
    "Start {amount}-day free trial": "Почни {amount}-денний безплатний період",
    "Starting {startDate}": "Починаючи з {startDate}",
    "Starting today": "Починаючи з сьогоднішнього дня",
    "State": "",
    "Submit feedback": "Надіслати відгук",
    "Subscribe": "Підписатися",
    "Subscribed": "Підписаний",
    "Subscription plan updated successfully": "План підписки успішно оновлено",
    "Success": "Успіх",
    "Success! Check your email for magic link to sign-in.": "Успіх! Перевірте свою електронну пошту на наявність посилання для входу.",
    "Success! Your account is fully activated, you now have access to all content.": "Успіх! Ваш обліковий запис повністю активовано, тепер ви маєте доступ до всього вмісту.",
    "Success! Your email is updated.": "Успіх! Ваша електронна адреса оновлена.",
    "Successfully unsubscribed": "Підписку успішно скасовано",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Дякуємо за підписку. Перш ніж почати читати, нижче наведено кілька інших сайтів, які можуть вам сподобатися.",
    "Thank you for your support": "Дякуємо за вашу підтримку",
    "Thank you for your support!": "Дякуємо за підтримку!",
    "Thanks for the feedback!": "Дякуємо за відгук!",
    "That didn't go to plan": "Щось пішло не так",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Адреса електронної пошти, яку є внас — {memberEmail} — якщо вона не вірна, ви можете оновити її в <button>налаштуваннях облікового запису</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Під час надсилання відгуку виникла проблема. Спробуйте ще раз трохи пізніше.",
    "There was an error cancelling your subscription, please try again.": "Під час скасування вашої підписки сталася помилка. Спробуйте ще раз.",
    "There was an error continuing your subscription, please try again.": "Під час продовження підписки сталася помилка. Спробуйте ще раз.",
    "There was an error processing your payment. Please try again.": "Під час обробки вашого платежу сталася помилка. Спробуйте ще раз.",
    "There was an error sending the email, please try again": "Під час надсилання листа сталася помилка. Повторіть спробу",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Цей сайт доступний тільки за запрошенням, звернись до власника сайта для доступу.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "Цей сайт на даний момент не приймає платежі.",
    "This site only accepts paid members.": "",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Щоб завершити реєстрацію, натисни посилання в своїй електронній пошті для підтвердження. Якщо електронний лист не прийде протягом 3 хвилин, перевір папку спам!",
    "To continue to stay up to date, subscribe to {publication} below.": "Щоб і надалі бути в курсі подій, підпишіться на {publication}.",
    "Too many attempts try again in {number} days.": "Забагато спроб, повторіть спробу через {number} днів.",
    "Too many attempts try again in {number} hours.": "Забагато спроб, повторіть спробу через {number} годин.",
    "Too many attempts try again in {number} minutes.": "Забагато спроб, повторіть спробу через {number} хвилин.",
    "Too many different sign-in attempts, try again in {number} days": "Забагато різних спроб входу. Повторіть спробу через {number} днів",
    "Too many different sign-in attempts, try again in {number} hours": "Забагато різних спроб входу. Повторіть спробу через {number} годин",
    "Too many different sign-in attempts, try again in {number} minutes": "Забагато різних спроб входу. Повторіть спробу через {number} хвилин",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Спробуйте безкоштовно протягом {amount} днів, надалі за {originalPrice}.",
    "Unable to initiate checkout session": "Не вдалося розпочати сеанс оформлення замовлення",
    "Unable to verify your request, please try again": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Розблокуйте доступ до всіх розсилок, ставши платним підписником.",
    "Unsubscribe from all emails": "Відписатись від усіх листів",
    "Unsubscribed": "Скасував підписку",
    "Unsubscribed from all emails.": "Скасував підписку на всі листи.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Відписка від листів не скасує твою платну підписку на {title}",
    "Update": "Оновити",
    "Update your preferences": "Онови свої налаштування",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Посилання для підтвердження надіслано, перевірте свою поштову скриньку",
    "Verify your email address is correct": "Переконайтеся, що ваша електронна адреса правильна",
    "Verifying...": "",
    "View plans": "Переглянути плани",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Ми не можемо вас відписати, оскільки адреса електронної пошти не знайдена. Будь ласка, зв'яжись з власником сайту.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "З поверненням, {name}!",
    "Welcome back!": "З поверненням!",
    "Welcome to {siteTitle}": "Вітаємо на {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Коли скринька \"Вхідні\" не може прийняти електронний лист, це зазвичай називають відмовою. У багатьох випадках це може бути тимчасовим. Однак у деяких випадках відхилений електронний лист може бути повернуто як постійна помилка, якщо адреса електронної пошти недійсна або не існує.",
    "Why has my email been disabled?": "Чому мою електронну пошту вимкнено?",
    "X (Twitter)": "",
    "year": "Рік",
    "Yearly": "Щорічно",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Наразі у вас є безкоштовне членство, перейдіть на платну підписку для повного доступу.",
    "You have been successfully resubscribed": "Ви успішно повторно підписалися",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Зараз ви не отримуєте електронних листів",
    "You're not receiving emails": "Ви не отримуєте електронних листів",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Ви не отримуєте електронні листи, тому що ви або позначили останнє повідомлення як спам, або тому, що повідомлення не можуть бути доставлені на надану вами адресу електронної пошти.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_many": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_many": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Ви успішно увійшли.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Ви успішно підписалися на <strong>{siteTitle}</strong>",
    "Your account": "Ваш обліковий запис",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Не вдалося повторно підписатися за вашою електронну адресою, спробуйте ще раз",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Ваш відгук допомагає обирати що публікувати далі.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Термін дії вашої підписки закінчується {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Ваша підписка буде продовжена {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Ваша підписка почне діяти {subscriptionStart}"
}
